import React from "react";
import { useSearchParams } from "react-router-dom";
import "../styles/QuestionPalette.scss";

const QuestionPalette = ({
  questions,
  currentQuestionIndex,
  setCurrentQuestionIndex,
  testAnswers,
  visitedQuestions = new Set(),
}) => {
  const [searchParams] = useSearchParams();
  const isReviewMode = searchParams.get("review") === "true";
  const getQuestionId = (q) => {
    let content = q.content || q;
    try {
      if (typeof content === "string") content = JSON.parse(content);
      if (typeof content === "string") content = JSON.parse(content);
    } catch (e) {}

    const type = (q.type || "").toLowerCase().trim();
    const questionObj =
      type === "match" ? content : content?.questions?.[0] || content;

    return (
      content?.question_id ||
      content?.id ||
      q.question_id ||
      q.id ||
      q._id ||
      q.sequence ||
      questionObj?.question_id ||
      questionObj?.id ||
      questionObj?.question
    );
  };

  const getQuestionStatus = (question, index) => {
    let content = question.content || question;
    try {
      if (typeof content === "string") content = JSON.parse(content);
      if (typeof content === "string") content = JSON.parse(content);
    } catch (e) {}

    const type = (question.type || "").toLowerCase().trim();
    const questionObj =
      type === "match" ? content : content?.questions?.[0] || content;

    const questionId = getQuestionId(question);

    const isCurrent = index === currentQuestionIndex;
    const isVisited = visitedQuestions.has(index);

    const isRetest = searchParams.get("retest") === "true";
    const isAnswered =
      (testAnswers[questionId] !== undefined &&
        testAnswers[questionId] !== null &&
        testAnswers[questionId] !== "" &&
        (!isRetest || isVisited)) ||
      (!isRetest && (question.attended || content.attended));

    if (isReviewMode && isAnswered) {
      const userAnswer = testAnswers[questionId];
      let correctAnswer = questionObj?.answer || questionObj?.correct_answer;

      let isCorrect = question.isCorrect;

      if (isCorrect === undefined) {
        if (type === "trueorfalse" || type === "truefalse") {
          const normalizedUser = String(userAnswer).toLowerCase();
          const normalizedCorrect = String(correctAnswer).toLowerCase();

          const userIsTrue =
            normalizedUser === "a" || normalizedUser === "true";
          const correctIsTrue =
            normalizedCorrect === "a" || normalizedCorrect === "true";

          isCorrect = userIsTrue === correctIsTrue;
        } else if (type === "fillups") {
          const userValue = userAnswer?.value || userAnswer;
          const normUser = String(userValue).trim().toLowerCase();
          const normCorrect = String(correctAnswer).trim().toLowerCase();
          isCorrect = normUser === normCorrect;
        } else {
          const normUser = String(userAnswer).trim().toLowerCase();
          const normCorrect = String(correctAnswer).trim().toLowerCase();
          isCorrect = normUser === normCorrect;
        }
      }

      if (isCurrent) {
        return isCorrect ? "current-correct" : "current-wrong";
      }
      return isCorrect ? "correct" : "wrong";
    }

    if (isCurrent) return "current";
    if (isAnswered) return "answered";
    if (isVisited) return "not-answered";
    return "not-visited";
  };

  return (
    <div className="question-palette-sidebar">
      <div className="palette-header">
        <h3>Question Palette</h3>
      </div>

      <div className="palette-grid custom-scrollbar">
        {questions.map((question, index) => {
          const status = getQuestionStatus(question, index);
          return (
            <button
              key={index}
              className={`palette-item ${status}`}
              onClick={() => setCurrentQuestionIndex(index)}
            >
              {index + 1}
            </button>
          );
        })}
      </div>

      <div className="palette-legend">
        {isReviewMode ? (
          <>
            <div className="legend-item">
              <span className="dot current-correct"></span>
              <span>Current (Correct)</span>
            </div>
            <div className="legend-item">
              <span className="dot current-wrong"></span>
              <span>Current (Wrong)</span>
            </div>
            <div className="legend-item">
              <span className="dot correct"></span>
              <span>Correct</span>
            </div>
            <div className="legend-item">
              <span className="dot wrong"></span>
              <span>Wrong</span>
            </div>
          </>
        ) : (
          <>
            <div className="legend-item">
              <span className="dot current"></span>
              <span>Current</span>
            </div>
            <div className="legend-item">
              <span className="dot answered"></span>
              <span>Answered</span>
            </div>
            <div className="legend-item">
              <span className="dot not-answered"></span>
              <span>Not Answered</span>
            </div>
            <div className="legend-item">
              <span className="dot not-visited"></span>
              <span>Not Visited</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default QuestionPalette;
